import styled, { createGlobalStyle } from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-courses-page {
    .courses-area {
      padding: 70px 0;

      .card-box {
        background: #fff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.08);
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }

      .actions {
        display: flex;
        flex-direction: column;
        gap: 15px;

        button {
          width: fit-content;
          background: ${colors.red_bg};
          border: none;
          color: #fff;
          text-transform: uppercase;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 5px;
          &:hover {
            background: ${colors.red_bg2};
          }
        }

        .search-form {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          input {
            flex: 1;
            min-width: 240px;
            border: 1px solid ${colors.border3};
            border-radius: 4px;
            padding: 10px 12px;
            font-size: 14px;
          }

          button {
            padding: 10px 18px;
            border-radius: 4px;
            border: none;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            background: ${colors.red_bg};
            color: #fff;
            cursor: pointer;
            transition: background 0.2s ease;
            &:hover {
              background: ${colors.red_bg2};
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
              background: ${colors.border3};
              color: ${colors.text3};
            }
          }

          .clear-btn {
            background: transparent;
            color: ${colors.text3};
            border: 1px solid ${colors.border3};
            &:hover {
              color: #fff;
              background: ${colors.red};
              border-color: ${colors.red};
            }
            &:disabled {
              background: transparent;
              color: ${colors.text3};
              border-color: ${colors.border3};
            }
          }
        }

        .bulk-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          button {
            padding: 9px 18px;
            border-radius: 4px;
            border: 1px solid ${colors.border3};
            background: #fff;
            color: ${colors.text2};
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover:not(:disabled) {
              color: #fff;
              background: ${colors.red_bg};
              border-color: ${colors.red_bg};
            }

            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }

          .export-btn {
            &:hover:not(:disabled) {
              background: ${colors.red_bg2};
            }
          }

          .import-btn {
            &:hover:not(:disabled) {
              background: ${colors.red};
              border-color: ${colors.red};
              color: #fff;
            }
          }
        }

        .file-input-hidden {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          border: 0;
        }

        .import-status {
          margin-top: 10px;

          .alert {
            font-size: 13px;
            ul {
              padding-left: 18px;
            }
          }
        }

        .filters-panel {
          border: 1px solid ${colors.border3};
          border-radius: 6px;
          background: #f9fbfd;
          padding: 15px;
          display: flex;
          flex-direction: column;
          gap: 12px;

          .filters-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;

            .filters-title {
              font-size: 14px;
              font-weight: 600;
              text-transform: uppercase;
              color: ${colors.text2};
            }

            .add-filter-btn {
              border: 1px solid ${colors.border3};
              background: #fff;
              color: ${colors.text2};
              border-radius: 4px;
              padding: 6px 14px;
              font-size: 13px;
              font-weight: 600;
              text-transform: uppercase;
              cursor: pointer;
              transition: all 0.2s ease;

              &:hover {
                border-color: ${colors.red};
                color: ${colors.red};
              }

              &:disabled {
                opacity: 0.6;
                cursor: not-allowed;
              }
            }
          }

          .filters-body {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .no-filters-available {
              font-size: 13px;
              color: ${colors.text3};
            }

            .filter-row {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              align-items: center;

              select,
              input {
                min-width: 140px;
                padding: 8px 12px;
                border: 1px solid ${colors.border3};
                border-radius: 4px;
                font-size: 13px;
                flex: 1;
              }

              input[type="number"] {
                max-width: 160px;
              }

              .remove-filter-btn {
                border: 1px solid ${colors.border3};
                border-radius: 4px;
                background: transparent;
                color: ${colors.red};
                font-size: 13px;
                font-weight: 600;
                padding: 6px 12px;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover:not(:disabled) {
                  border-color: ${colors.red};
                  background: rgba(255, 111, 111, 0.1);
                }

                &:disabled {
                  opacity: 0.6;
                  cursor: not-allowed;
                }
              }
            }
          }

          .filters-footer {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            gap: 10px;

            .filters-summary {
              font-size: 13px;
              color: ${colors.text3};
            }

            .filters-buttons {
              display: flex;
              gap: 10px;
              flex-wrap: wrap;

              button {
                padding: 8px 16px;
                border-radius: 4px;
                border: none;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
                cursor: pointer;
                transition: background 0.2s ease, color 0.2s ease;

                &:disabled {
                  opacity: 0.6;
                  cursor: not-allowed;
                }
              }

              .apply-filters-btn {
                background: ${colors.red_bg};
                color: #fff;

                &:hover:not(:disabled) {
                  background: ${colors.red_bg2};
                }
              }

              .clear-filters-btn {
                background: transparent;
                border: 1px solid ${colors.border3};
                color: ${colors.text2};

                &:hover:not(:disabled) {
                  border-color: ${colors.red};
                  color: ${colors.red};
                }
              }
            }
          }
        }
      }

      .data-grid {
        table {
          width: 100%;
          border-collapse: collapse;

          th,
          td {
            padding: 12px 14px;
            border: 1px solid ${colors.border3};
            vertical-align: middle;
            font-size: 14px;
          }

          th {
            background: ${colors.red_bg};
            color: #fff;
            text-transform: uppercase;
            font-weight: 600;
          }

          tbody tr:nth-child(odd) {
            background: #fafafa;
          }

          tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
        }

        .actions-cell {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;

          .link-button {
            background: transparent;
            border: none;
            color: ${colors.red};
            text-decoration: underline;
            cursor: pointer;
            padding: 0;
            font-size: 14px;
            font-weight: 600;
            &:hover {
              color: ${colors.red2};
            }
            &.apply {
              color: ${colors.red};
              &:hover {
                color: ${colors.red2};
              }
            }
            &.view {
              color: ${colors.blue};
              &:hover {
                color: #1f78c1;
              }
            }
            &.delete {
              color: ${colors.red};
              &:hover {
                color: #d13f3f;
              }
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }

          .divider {
            color: ${colors.text3};
          }
        }

        .pagination-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          gap: 15px;
          flex-wrap: wrap;

          .page-info {
            font-size: 14px;
            color: ${colors.text3};
          }

          .page-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            button {
              padding: 8px 16px;
              border-radius: 4px;
              border: 1px solid ${colors.border3};
              background: ${colors.red_bg};
              color: #fff;
              font-size: 14px;
              font-weight: 600;
              transition: background 0.2s ease;
              &:hover {
                background: ${colors.red_bg2};
              }
              &:disabled {
                opacity: 0.55;
                cursor: not-allowed;
                background: ${colors.border3};
                color: ${colors.text3};
              }
            }

            select {
              border: 1px solid ${colors.border3};
              border-radius: 4px;
              padding: 8px 12px;
              font-size: 14px;
            }
          }
        }
      }
    }

    @media (max-width: 767px) {
      .courses-area {
        padding: 40px 0;

        .card-box {
          padding: 20px;
        }

        .actions {
          button {
            width: 100%;
          }

          .search-form {
            flex-direction: column;
            input {
              min-width: 100%;
            }
            button {
              width: 100%;
            }
          }
        }

        .data-grid {
          overflow-x: auto;
        }
      }
    }
  }
`;

export const CourseModalStyles = createGlobalStyle`
    .admin-courses-modal {
        height: calc(100vh - 2rem);
        margin-top: 1rem;
        margin-bottom: 1rem;

        .modal-content {
            border-radius: 10px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.18);
            height: 100%;
            max-height: 100%;
            overflow: hidden;

            > form {
                display: flex;
                flex-direction: column;
                min-height: 0;
                height: 100%;
            }
        }

        .modal-header {
            border-bottom: 1px solid ${colors.border1};
            padding: 20px 24px;
            flex-shrink: 0;

            h5 {
                font-size: 18px;
                font-weight: 600;
                color: ${colors.black1};
            }
        }

        .modal-body {
            padding: 24px;
            background: ${colors.bg2};
            min-height: 0;
            overflow-y: auto;
            scrollbar-gutter: stable;
            overscroll-behavior: contain;

            .program-details-heading {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                margin-bottom: 8px;

                label {
                    margin-bottom: 0;
                }

                .program-details-heading-actions {
                    display: flex;
                    gap: 8px;
                    flex-wrap: wrap;
                }
            }

            .file-input-hidden {
                position: absolute;
                width: 1px;
                height: 1px;
                padding: 0;
                margin: -1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                border: 0;
            }

            .program-details-file-error {
                margin-top: 8px;
                margin-bottom: 0;
                font-size: 13px;
                padding: 8px 12px;
            }

            .program-details-editor {
                .ql-container {
                    height: 280px;
                }

                .ql-editor {
                    overflow-y: auto;
                }
            }

            .program-details-html-editor {
                min-height: 320px;
                overflow-y: auto;
                resize: vertical;
                font-family: SFMono-Regular, Consolas, "Liberation Mono", monospace;
                line-height: 1.5;
            }

            .program-details-preview {
                margin-top: 12px;
                border: 1px solid ${colors.border3};
                border-radius: 6px;
                overflow: hidden;

                .program-details-preview-label {
                    background: #f1f3f5;
                    color: ${colors.text3};
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    padding: 6px 12px;
                    border-bottom: 1px solid ${colors.border3};
                }

                .program-details-preview-frame {
                    width: 100%;
                    height: 500px;
                    border: none;
                    display: block;
                    background: #fff;
                }
            }

            label {
                font-size: 14px;
                font-weight: 600;
                color: ${colors.black1};
            }

            input,
            textarea,
            select {
                font-size: 14px;
            }
        }

        .modal-footer {
            border-top: 1px solid ${colors.border1};
            padding: 16px 24px;
            flex-shrink: 0;
        }
    }

    @media (max-width: 575px) {
        .admin-courses-modal {
            height: calc(100vh - 1rem);
            margin: 0.5rem;
        }
    }

    .admin-courses-apply-modal {
        .modal-content {
            border-radius: 10px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.18);
        }

        .modal-header {
            border-bottom: 1px solid ${colors.border1};
            padding: 20px 24px;

            h5 {
                font-size: 18px;
                font-weight: 600;
                color: ${colors.black1};
            }
        }

        .modal-body {
            padding: 24px;
            background: ${colors.bg2};
            display: flex;
            flex-direction: column;
            gap: 18px;

            label {
                font-size: 14px;
                font-weight: 600;
                color: ${colors.black1};
            }

            input,
            textarea,
            select {
                font-size: 14px;
            }

            .course-summary {
                background: #fff;
                border: 1px solid ${colors.border1};
                border-radius: 6px;
                padding: 16px;

                h5 {
                    font-size: 16px;
                    margin-bottom: 6px;
                    color: ${colors.black1};
                }

                .university {
                    margin: 0 0 10px 0;
                    font-weight: 600;
                    color: ${colors.text2};
                }

                .meta {
                    margin: 0;
                    padding: 0;

                    li {
                        font-size: 13px;
                        color: ${colors.text3};

                        strong {
                            color: ${colors.black1};
                            margin-right: 4px;
                        }
                    }
                }
            }

            .user-picker {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .user-search {
                    display: flex;
                    gap: 10px;
                    flex-wrap: nowrap;

                    input {
                        flex: 1;
                    }

                    button {
                        white-space: nowrap;
                    }
                }

                .loading-users {
                    text-align: center;
                    padding: 10px 0;

                    .spinner-border {
                        color: ${colors.red};
                    }
                }

                .user-select {
                    min-height: 42px;
                }

                .muted {
                    color: ${colors.text3};
                    font-size: 12px;
                }
            }
        }

        .modal-footer {
            border-top: 1px solid ${colors.border1};
            padding: 16px 24px;
        }
    }
`;
